
<template>
    <img
        class="logo"
        src="/images/zeto.png"
        alt="ZETO Inc." >
</template>
